import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Usuario'

  constructor(private httpClient: HttpClient) {}

  public createUser(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/create`, model)
  }
  public resetPassword(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/reset-senha/${id}`, {})
  }
  public createEmployee(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/AcessoSistema/Funcionario`,
      model,
    )
  }
  public createResposibleForSupplier(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/AcessoSistema/Fornecedor`,
      model,
    )
  }
  public editUser(
    model: any,
    // model: EditUserModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/edit`, model)
  }

  public deleteUser(
    model: any,
    // model: DeleteUserModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/delete`, model)
  }

  public listPagedEmployee(page: number, rows: number = 15, orderBy: string = ''): Observable<ResponseRequestModel> {
    if (orderBy.length > 0) {
      orderBy = 'orderBy=' + orderBy
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/funcionario?pageNumber=${page}&pageSize=${rows}&${orderBy}`,
    )
  }
  public listPagedDriver(page: number, rows: number = 15, orderBy: string = ''): Observable<ResponseRequestModel> {
    if (orderBy.length > 0) {
      orderBy = 'orderBy=' + orderBy
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/motorista?pageNumber=${page}&pageSize=${rows}&${orderBy}`,
    )
  }
  public listPagedDriverBySupplier(
    page: number,
    rows: number = 15,
    orderBy: string = '',
    fornecedor: number,
  ): Observable<ResponseRequestModel> {
    let paramFornecedor = ''
    if (orderBy.length > 0) {
      orderBy = 'orderBy=' + orderBy
    }
    if (fornecedor !== 0) {
      paramFornecedor = 'PessoaIdFornecedor=' + fornecedor.toString()
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/motorista?pageNumber=${page}&pageSize=${rows}&${orderBy}&${paramFornecedor}`,
    )
  }
  public listPagedSupplier(page: number, rows: number = 15, orderBy: string = ''): Observable<ResponseRequestModel> {
    if (orderBy.length > 0) {
      orderBy = 'orderBy=' + orderBy
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/fornecedor?pageNumber=${page}&pageSize=${rows}&${orderBy}`,
    )
  }
  public listUser(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listall`)
  }

  public searchPagedEmployee(
    page: number,
    rows: number = 15,
    orderBy: string = '',
    model: any,
  ): Observable<ResponseRequestModel> {
    let params = new HttpParams().set('pageNumber', String(page)).set('pageSize', String(rows))

    Object.entries(model).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value))
      }
    })

    if (orderBy?.length > 0) {
      params = params.set('orderBy', orderBy)
    }

    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listpaginated/funcionario`, {
      params,
    })
  }
  public searchPagedDriver(
    page: number,
    rows: number = 15,
    orderBy: string = '',
    model: any,
  ): Observable<ResponseRequestModel> {
    let params = new HttpParams().set('pageNumber', String(page)).set('pageSize', String(rows))

    Object.entries(model).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value))
      }
    })

    if (orderBy?.length > 0) {
      params = params.set('orderBy', orderBy)
    }

    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listpaginated/motorista`, {
      params,
    })
  }
  public searchPagedDriverBySupplier(
    page: number,
    rows: number = 15,
    orderBy: string = '',
    model: any,
    fornecedor: number,
  ): Observable<ResponseRequestModel> {
    let params = new HttpParams().set('pageNumber', String(page)).set('pageSize', String(rows))

    Object.entries(model).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value))
      }
    })

    if (orderBy?.length > 0) {
      params = params.set('orderBy', orderBy)
    }
    if (fornecedor !== 0) {
      params = params.set('PessoaIdFornecedor', fornecedor)
    }
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listpaginated/motorista`, {
      params,
    })
  }
  public searchPagedSupplier(
    page: number,
    rows: number = 15,
    orderBy: string = '',
    model: any,
  ): Observable<ResponseRequestModel> {
    let params = new HttpParams().set('pageNumber', String(page)).set('pageSize', String(rows))

    Object.entries(model).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value))
      }
    })

    if (orderBy?.length > 0) {
      params = params.set('orderBy', orderBy)
    }

    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listpaginated/fornecedor`, {
      params,
    })
  }
  public getUserbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/${id}`)
  }

  public searchPagedUser(page: number, rows: number = 15, model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public changePassword(model: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/edit/senha-usuario`, model)
  }
  public changeStatus(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(`${this.baseUrl}${this.resource}/toggle-status/${id}`, {})
  }
}
